/** @format */

export enum DocumentTemplate {
  V1 = 'v1',
  V2 = 'v2',
  LITE = 'lite',
}
